import { UserPlus, UsersRound } from 'lucide-react';
import { Button } from '../../../../design-system/button/button';
import { Stack } from '../../../../design-system/stack/stack';

type EmptyStateProps = {
  onAddEmployee: () => void;
};

export const EmptyState = ({ onAddEmployee }: EmptyStateProps) => {
  return (
    <Stack align="center" className="mt-10">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white">
        <UsersRound className="h-7 w-7" strokeWidth={1} />
      </div>

      <Stack space={4} align="center">
        <Stack space={2} align="center">
          <h2 className="text-xl">Add your first employee</h2>
          <p className="text-sm text-seapoint-gray-text">Add employee manually with our easy form</p>
        </Stack>

        <Button iconLeft={<UserPlus />} onClick={onAddEmployee}>
          Add Employee
        </Button>
      </Stack>
    </Stack>
  );
};
